export function isHeartbeatSchedulerToolName(name?: string): boolean {
  if (!name) return false;
  if (name === "heartbeat") return true;

  const toolNamespace = name.split(".")[0];
  return (
    toolNamespace === "scheduler" || toolNamespace === "heartbeat-scheduler"
  );
}

export function getToolDisplayName(name?: string): string | undefined {
  if (!name) return name;
  return isHeartbeatSchedulerToolName(name) ? "heartbeat" : name;
}
